<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import { shouldBeUrl } from 'shared/helpers/Validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      gatewayUrl:
        window.chatwootConfig?.whatsappPersonalGatewayUrl ||
        'http://whatsapp_personal_gateway:3100',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    gatewayUrl: { required, shouldBeUrl },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName?.trim(),
            channel: {
              type: 'whatsapp',
              provider: 'whatsapp_personal',
              provider_config: {
                gateway_url: this.gatewayUrl?.trim(),
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <p class="mb-6 text-sm leading-relaxed text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.WHATSAPP.PERSONAL.DESCRIPTION') }}
    </p>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.gatewayUrl.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PERSONAL.GATEWAY_URL.LABEL') }}
        <input
          v-model="gatewayUrl"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.PERSONAL.GATEWAY_URL.PLACEHOLDER')
          "
          @blur="v$.gatewayUrl.$touch"
        />
        <span v-if="v$.gatewayUrl.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PERSONAL.GATEWAY_URL.ERROR') }}
        </span>
      </label>
      <p class="mt-1 text-sm text-n-slate-11">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PERSONAL.GATEWAY_URL.HINT') }}
      </p>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.PERSONAL.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
